import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "@src/utils/baseQuery";

export interface VideoControlsConfig {
  allowForward: boolean | null;
  lockForward: boolean | null;
  allowReplay: boolean | null;
  lockReplay: boolean | null;
  allowDownload: boolean | null;
  lockDownload: boolean | null;
  allowPlaybackSpeed: boolean | null;
  lockPlaybackSpeed: boolean | null;
  allowOverride: boolean | string | null;
}

export interface VideoControlsResponse {
  statusCode: number;
  httpStatus: string;
  response: VideoControlsConfig;
}

export interface OrgVideoControlsContext {
  globalDefaults: VideoControlsConfig;
  organizationDefaults: VideoControlsConfig;
}

export interface OrgVideoControlsResponse {
  statusCode: number;
  httpStatus: string;
  response: OrgVideoControlsContext;
}

export const VideoConfigApiSlice = createApi({
  reducerPath: "VideoConfigApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["VideoControls"],
  endpoints: (builder) => ({
    getGlobalVideoControls: builder.query<VideoControlsResponse, void>({
      query: () => ({
        url: "global-settings/video-controls",
        method: "GET",
      }),
      providesTags: ["VideoControls"],
    }),
    updateGlobalVideoControls: builder.mutation<any, VideoControlsConfig>({
      query: (body) => ({
        url: "global-settings/video-controls",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["VideoControls"],
    }),
    getOrgVideoControlsContext: builder.query<
      OrgVideoControlsResponse,
      { organizationId: string }
    >({
      query: ({ organizationId }) => ({
        url: `organization/${organizationId}/video-controls-context`,
        method: "GET",
      }),
      providesTags: ["VideoControls"],
    }),
    updateOrgVideoControls: builder.mutation<
      any,
      { organizationId: string; body: VideoControlsConfig }
    >({
      query: ({ organizationId, body }) => ({
        url: `organization/${organizationId}/video-controls`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["VideoControls"],
    }),
  }),
});

export const {
  useGetGlobalVideoControlsQuery,
  useUpdateGlobalVideoControlsMutation,
  useGetOrgVideoControlsContextQuery,
  useUpdateOrgVideoControlsMutation,
} = VideoConfigApiSlice;
